/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { twJoin } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Checkbox from 'shopper/components/Checkbox';
import Heading from 'shopper/components/Heading';
import Link from 'shopper/components/Link';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

const MAX_INITIALLY_VISIBLE_STORES = 5;

const isStoreChecked = (stores, storeId) =>
  stores.some((store) => store.storeId === storeId);

const FilterOffersByStore = ({
  gaEventCategory,
  isWithinDrawer = false,
  stores,
  storesList,
  onOffersFiltersResetClick,
  onOffersStoresFilterChange,
}) => {
  const [tempOffersFiltersStores, setTempOffersFiltersStores] =
    useState(stores);
  const [isAllStoresVisible, setAllStoresVisible] = useState(false);

  useEffect(() => {
    setTempOffersFiltersStores(stores);
  }, [stores]);

  const onCheckboxChange = ({ isChecked, storeId, storeName }) => {
    sendEvent({
      category: gaEventCategory,
      action: 'filter_store',
      value: storeName,
    });

    setTempOffersFiltersStores((prev) => {
      if (isChecked) {
        const isStoreAlreadySetAsFilter = prev.some(
          (store) => store.storeId === storeId
        );

        return isStoreAlreadySetAsFilter
          ? prev
          : [...prev, { storeId, storeName }];
      }

      return prev.filter((store) => store.storeId !== storeId);
    });
  };

  const onShowAllStoresToggle = () => setAllStoresVisible((prev) => !prev);

  return (
    <Box
      className={twJoin(
        'w-full py-4',
        isWithinDrawer ? 'mt-6' : 'mb-4 mt-0 px-4'
      )}
    >
      <div className="mb-2 flex items-center justify-between">
        <Heading as="span" size="size5">
          Filtrar por
        </Heading>
        <Link onClick={onOffersFiltersResetClick}>
          {placeholder('actions.resetFilters')}
        </Link>
      </div>
      <div className="flex flex-col items-start pt-4">
        <Text className="mb-2" bold>
          Loja
        </Text>
        <div className="flex flex-col overflow-y-hidden pb-1">
          {storesList
            .slice(
              0,
              isAllStoresVisible
                ? storesList.length
                : MAX_INITIALLY_VISIBLE_STORES
            )
            .map(({ storeId, storeName }) => (
              <Checkbox
                key={storeId}
                checked={isStoreChecked(tempOffersFiltersStores, storeId)}
                className="mt-2"
                label={storeName}
                name={storeName}
                onClick={({ target }) => {
                  onCheckboxChange({
                    storeId,
                    storeName,
                    isChecked: target.checked,
                  });
                }}
              />
            ))}
        </div>
        {storesList.length > MAX_INITIALLY_VISIBLE_STORES && (
          <Link className="mt-4" size="size1" onClick={onShowAllStoresToggle}>
            {isAllStoresVisible
              ? placeholder('actions.seeLess')
              : placeholder('actions.seeAll')}
          </Link>
        )}
        <Button
          className="mt-4"
          size="size2"
          full
          onClick={() => onOffersStoresFilterChange(tempOffersFiltersStores)}
        >
          {placeholder('actions.applyFilter')}
        </Button>
      </div>
    </Box>
  );
};

FilterOffersByStore.propTypes = {
  isWithinDrawer: PropTypes.bool,
  gaEventCategory: PropTypes.string.isRequired,
  storesList: PropTypes.arrayOf(
    PropTypes.shape({
      storeId: PropTypes.number.isRequired,
      storeName: PropTypes.string.isRequired,
    })
  ).isRequired,
  onOffersFiltersResetClick: PropTypes.func.isRequired,
  onOffersStoresFilterChange: PropTypes.func.isRequired,
};

export default FilterOffersByStore;
